export const ROUTES_PATHNAME = {
    home: {
        label: 'INICIO',
        href: '/'
    },
    courses: {
        label: 'OFERTA ACADEMICA',
        href: '/capacitaciones'
    }
}